// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23F59201%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%0A%3E%3Cpolyline points=%276 9 12 15 18 9%27 /%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown--kv06L {
  position: relative;
  width: auto;
  color: black;
  text-transform: uppercase;
}[dir] .dropdown--kv06L {
  background-color: transparent;
  box-shadow: none;
  border-bottom: 1px solid black;
  border-radius: 0;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}[dir=ltr] .dropdown--kv06L {
  padding: 0 30px 0 5px;
  background-position: right;
}[dir=rtl] .dropdown--kv06L {
  padding: 0 5px 0 30px;
  background-position: left;
}

.dropdown--kv06L:focus-visible {
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/SettingsPanel/subComponents/SignificantChangesPanel/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EAEX,YAAY;EAKZ,yBAAyB;AAI3B,CAbA;EAGE,6BAA6B;EAE7B,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAGhB,4BAA4B;EAE5B,yDAAuR;AACzR,CAbA;EAQE,qBAAqB;EAGrB,0BAA0B;AAE5B,CAbA;EAQE,qBAAqB;EAGrB,yBAA0B;AAE5B;;AAEA;EACE,aAAa;AACf","sourcesContent":[".dropdown {\n  position: relative;\n  width: auto;\n  background-color: transparent;\n  color: black;\n  box-shadow: none;\n  border-bottom: 1px solid black;\n  border-radius: 0;\n  padding: 0 30px 0 5px;\n  text-transform: uppercase;\n  background-repeat: no-repeat;\n  background-position: right;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23F59201' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%0A%3E%3Cpolyline points='6 9 12 15 18 9' /%3E%3C/svg%3E\");\n}\n\n.dropdown:focus-visible {\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `dropdown--kv06L`
};
export default ___CSS_LOADER_EXPORT___;
